import type { MouseEventHandler, ReactNode } from 'react';
import { CaretLeft, CaretRight } from '@phosphor-icons/react';
import { css, cx, resetButtonStyle } from '@eti/styles';
import { useDirection } from '@eti/providers';
import { breakpoints } from '@etg/wings';

const buttonStyles = css`
  ${resetButtonStyle}; /* stylelint-disable-next-line */
  display: flex;
  justify-content: space-between;
  padding: 16px;
  width: 100%;
`;

const iconStyles = css`
  font-size: 1.125rem;

  @media (min-width: ${breakpoints._970}) {
    font-size: 1.3125rem;
  }
`;

const iconWrapperStyles = css`
  align-items: center;
  display: flex;
  height: 24px;
  justify-content: center;
  width: 24px;

  &:hover {
    cursor: pointer;
  }
`;

interface CaretButtonProps {
  children: ReactNode;
  className?: string;
  dataTestId?: string;
  onClick?: MouseEventHandler<HTMLButtonElement>;
}

const CaretButton = ({ children, className, onClick, dataTestId }: CaretButtonProps) => {
  const { isRTL } = useDirection();

  return (
    <button
      className={cx(buttonStyles, className)}
      data-testid={dataTestId}
      onClick={onClick}
      type="button"
    >
      {children}
      <div className={iconWrapperStyles}>
        {isRTL ? (
          <CaretLeft aria-hidden="true" className={iconStyles} color="#a6a6a6" weight="bold" />
        ) : (
          <CaretRight aria-hidden="true" className={iconStyles} color="#a6a6a6" weight="bold" />
        )}
      </div>
    </button>
  );
};

export default CaretButton;
